import { render, staticRenderFns } from "./ProductModel.vue?vue&type=template&id=25af4918&"
import script from "./ProductModel.vue?vue&type=script&lang=ts&"
export * from "./ProductModel.vue?vue&type=script&lang=ts&"
import style0 from "./ProductModel.vue?vue&type=style&index=0&lang=less&"
import style1 from "./ProductModel.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports